export default __webpack_public_path__ + "static/media/red-dot.43d67313.svg";